module.exports = __webpack_public_path__ + "static/media/161.7138d2e0.webp";